import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { BaseService } from './base.service';
import { ResponseModel } from '../models/api.model';

import { MessageService } from 'primeng/api';
import { environment } from '../environments/environment';


@Injectable()
export class SearchService extends BaseService {
  requireTimeZone = ["EST", "EDT"];
  timeZone = new Date()
    .toLocaleTimeString("en-us", { timeZoneName: "short" })
    .split(" ")[2];
  timeZoneFactor = new Date().getTimezoneOffset() / 60;

  constructor(
    private http: HttpClient,
    private router: Router,
    messageService: MessageService
  ) {
    super(messageService);
  }

  search(
    subject: string,
    params: any,
    query: string | null = null,
    first: number = 0,
    pageSize: number = 15,
    sortField: string | null = null,
    sortOrder: number = 0,
    multiSortMeta: string = "",
    duration: number = 1
  ) {
    if (params == null) params = {};
    // Sanitize search parameters to prevent injection
    params = this.sanitizePayload(params);
    params.first = first;
    params.pageSize = pageSize;
    params.sortField = sortField ? this.sanitizationService.sanitizeText(sortField) : null;
    params.sortOrder = sortOrder;
    params.query = query ? this.sanitizationService.sanitizeText(query) : null;
    params.multiSortMeta = multiSortMeta ? this.sanitizationService.sanitizeText(multiSortMeta) : "";
    params.duration = duration;
    params.timeZoneFactor = this.requireTimeZone.includes(this.timeZone)
      ? this.timeZoneFactor
      : null;

    let p = new HttpParams({ fromObject: params });

    return this.http
      .get(`${environment.baseUrl}api/search/${subject}`, { params: p })
      .pipe(
        map((res) => {
          return <ResponseModel<any>>res;
        })
      );
  }

  filters(subject: string) {
    return this.http
      .get(`${environment.baseUrl}api/search/filters/${subject}`)
      .pipe(
        map((res) => {
          return <ResponseModel<any[]>>res;
        })
      );
  }
}
